export default "__VITE_ASSET__r5RuCWaf__"